import * as yup from "yup";

export const schemaVerifyEmail = yup.object({
    token: yup
        .string()
        .length(6, "Token must be exactly 6 characters long")
        .required("Token is required"),
}).required();
